import React, { useContext, useMemo } from 'react'
import styles from '../styles.module.scss'
import { WebLessonsContext } from '../../../utils/context'
import { render } from '@testing-library/react'


const STUDENTS = [
  {name: 'Иванов Иван Иванович', id: 1},
  {name: 'Петров Петр Петрович', id: 2},
  {name: 'Сидоров Сидор Сидорович', id: 3},
  {name: 'Николаев Николай Николаевич', id: 4},
  {name: 'Михайлов Михаил Михайлович', id: 5},
]


const StudentsBlock = () => {
  
  const {participants, raisedHands, startDialogWith, activeDialog} = useContext(WebLessonsContext)

  const students = useMemo(() => participants.filter(p => p._attributes.position === 'student'), [participants])
  
  const studentClickHandler = (raisedHand, targetId, targetName) => () => {
    if (!raisedHand) return;
    startDialogWith(targetId, targetName)
  }
  
  const renderStudent = (student) => {
    const {sid} = student
    const {username} = student._attributes
    const raisedHand = !!raisedHands.find((participantId) => participantId === sid)
    return (
      <tr onClick={studentClickHandler(raisedHand, sid, username)} key={sid}>
        <td style={{color: raisedHand && 'green'}}>{username}</td>
      </tr>
    )
  }

  return (
    <div className={styles.studentsBlock}>
      <table>
        <thead>
          <tr>
            <th>ФИО учащегося</th>
            <th>оценки</th>
            <th>ДЗ</th>
          </tr>
        </thead>
        <tbody>
          {STUDENTS.map((student) => (
            <tr key={student.id}>
              <td>{student.name}</td>
            </tr>
          ))}
          {students.map(renderStudent)}
        </tbody>
      </table>
    </div>
  )
}

export default StudentsBlock